import { type UpdateHistoryResponseDto } from "@everon-it/api-client/contents-gw";
import { type CommonCreateBodyKeyType, type CommonDataType } from "src/types/common";

export type FaqDetailInitValuesType = {
    title: string;
    isVisible: boolean;
    mainCategory: string;
    middleCategory: string;
    content: string;
    reason: string;
    updateHistory: UpdateHistoryResponseDto[];
};

export const FaqDetailData: CommonDataType<CommonCreateBodyKeyType, FaqDetailInitValuesType> = {
    createBodyKey: ["isVisible", "mainCategory", "middleCategory", "title", "content", "uuid", "reason"],
    formInitialValues: {
        title: "",
        isVisible: false,
        mainCategory: "",
        middleCategory: "",
        content: "",
        reason: "",
        updateHistory: [],
    },
};
